/** @format */

import { Route } from "react-router-dom";
import AgentRootBeforeRender from "../pages/common/AgentRootBeforeRender";
import RedirectBeforeRender from "../pages/common/RedirectBeforeRender";
import BeforeRender from "../pages/common/BeforeRender";

import { BcartEntryColumn } from "../components/ui_elements/bcart/Entry/EntryColumn";

// 共通ページ
import Login from "../pages/common/Login";
import ResetPassword from "../pages/common/ResetPassword";
import ResetPasswordMail from "../pages/common/ResetPasswordMail";
import ResetPasswordMailCompleted from "../pages/common/ResetPasswordMailCompleted";
import ChangePasswordMail from "../pages/common/ChangePasswordMail";
import EntrySelect from "../pages/bcart/EntrySelect";
import SystemError from "../pages/common/SystemError";
import RedirectTimeout from "../pages/common/RedirectTimeout";

import DashBoard from "../pages/common/DashBoard";
import BcartEconomicEstimate from "../pages/bcart/EconomicEstimate";
import BcartEconomicEstimateCheck from "../pages/bcart/EconomicEstimateCheck";
import BcartEntryTop from "../pages/bcart/EntryTop";
import BcartEntry from "../pages/bcart/Entry";

import RedirectPassword from "../pages/common/RedirectPassword";
import BcartRedirectEconomic from "../pages/bcart/RedirectEconomic";

import EntryConfirm from "../pages/bcart/EntryConfirm";
import EntryCompleted from "../pages/common/EntryCompleted";
import EntryCheck from "../pages/bcart/EntryCheck";
import UseStart from "../pages/bcart/UseStart";
import ExaminationStatus from "../pages/bcart/ExaminationStatus";
import UseStartPrecautions from "../pages/common/UseStartPrecautions";
import Inquiry from "../pages/common/Inquiry";

const BcartRouting = [
  <Route path="bcart" element={<AgentRootBeforeRender agentPath="/bcart" />}>
    <Route path="login" element={<BeforeRender Component={Login} IsLoggedIn={false} />} />
    <Route path="reset_password_mail" element={<BeforeRender Component={ResetPasswordMail} IsLoggedIn={false} />} />
    <Route
      path="reset_password_mail_completed"
      element={<BeforeRender Component={ResetPasswordMailCompleted} IsLoggedIn={false} />}
    />
    <Route path="reset_password" element={<BeforeRender Component={ResetPassword} IsLoggedIn={false} />} />
    <Route path="system_error" element={<BeforeRender Component={SystemError} IsLoggedIn={false} />} />
    <Route path="redirect_timeout" element={<BeforeRender Component={RedirectTimeout} IsLoggedIn={false} />} />
    <Route path="change_password_mail" element={<BeforeRender Component={ChangePasswordMail} />} />
    <Route path="entry_select" element={<BeforeRender Component={EntrySelect} IsLoggedIn={false} />} />
    <Route path="dashboard" element={<BeforeRender Component={DashBoard} />} />
    <Route path="economic_estimate" element={<BeforeRender Component={BcartEconomicEstimate} />} />
    <Route path="economic_estimate_check" element={<BeforeRender Component={BcartEconomicEstimateCheck} />} />
    <Route
      path="redirect/economic_estimate_check"
      element={<RedirectBeforeRender Component={BcartEconomicEstimateCheck} redirect={true} />}
    />
    <Route path="entry_top" element={<BeforeRender Component={BcartEntryTop} />} />
    <Route path="entry" element={<BeforeRender Component={BcartEntry} />}>
      <Route path="merchant" element={<BcartEntryColumn path="merchant" />} />
      <Route path="bank_account" element={<BcartEntryColumn path="bank_account" />} />
      <Route path="shop" element={<BcartEntryColumn path="shop" />} />
    </Route>
    <Route
      path="redirect_economic_estimate"
      element={<RedirectBeforeRender Component={BcartRedirectEconomic} redirect={true} />}
    />
    <Route path="redirect" element={<RedirectBeforeRender Component={BcartEntry} redirect={true} />}>
      <Route path="merchant" element={<BcartEntryColumn path="merchant" redirect={true} />} />
      <Route path="bank_account" element={<BcartEntryColumn path="bank_account" redirect={true} />} />
      <Route path="shop" element={<BcartEntryColumn path="shop" redirect={true} />} />
    </Route>
    <Route path="redirect_password" element={<RedirectBeforeRender Component={RedirectPassword} redirect={true} />} />
    <Route path="redirect_confirm" element={<RedirectBeforeRender Component={EntryConfirm} redirect={true} />} />
    <Route path="redirect_completed" element={<RedirectBeforeRender Component={EntryCompleted} />} />
    <Route path="entry_confirm" element={<BeforeRender Component={EntryConfirm} />} />
    <Route path="entry_completed" element={<BeforeRender Component={EntryCompleted} />} />
    <Route path="entry_check" element={<BeforeRender Component={EntryCheck} />} />
    <Route path="use_start" element={<BeforeRender Component={UseStart} />} />
    <Route path="examination_status" element={<BeforeRender Component={ExaminationStatus} />} />
    <Route path="use_start_precautions" element={<BeforeRender Component={UseStartPrecautions} />} />
    <Route path="inquiry" element={<BeforeRender Component={Inquiry} />} />
  </Route>,
];

export default BcartRouting;
